import { useCallback } from "react";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { settingsAjax } from "../../ajax/SettingsAjax";
import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";
import { costUnit, CurrencyDTO, formatMoney, NO_CURRENCY } from "../../utilities/format/currency";

export const currencyQuery = queryOptions({
  queryKey: ['references', 'currency'],
  queryFn: async (): Promise<CurrencyDTO> => {
    const res = await settingsAjax.getCurrency();
    if (ErrorResponse.isErrorResponse(res)) throw new Error('Failed to load the currency');
    return res;
  },
  staleTime: Infinity,
});

export const useCurrency = () => useQuery(currencyQuery).data ?? NO_CURRENCY;

export const useMoney = () => {
  const currency = useCurrency();
  return useCallback((value: number | null | undefined, digits = 2) => formatMoney(value, currency, digits), [currency]);
};

export const useCostUnit = () => {
  const currency = useCurrency();
  return useCallback((unit: string | null | undefined) => costUnit(unit, currency), [currency]);
};
